import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import { Icons, theme } from "../../../../../../../../../../../assets";
import {
    Input,
    PrimaryButton,
    SecondaryButton,
} from "../../../../../../../../../../../components";
import { activities } from "../../../../../../../../../../../services";
import { queryClient } from "../../../../../../../../../../../utils/query-client/query-client";
import { AddCollaboratorsModal } from "../../../../../../../modals/add-collaborators/add-collaborators-modal";
import { TSectionActivity } from "../../../../../../../types";
import { ActivityDTO, SubItemDTO } from "../../../../../../types/activityDTO";
import * as s from "./styles";

type TEditSubItem = {
    activity: ActivityDTO;
    subItem: SubItemDTO;
    setEditSubItem: React.Dispatch<React.SetStateAction<boolean>>;
};

export const EditSubItem = ({
    activity,
    setEditSubItem,
    subItem,
}: TEditSubItem) => {
    const [title, setTitle] = useState(subItem.title);
    const [users, setUsers] = useState<string[]>(
        subItem.users.map((u) => u.User.id_e)
    );

    const activityToAddCollaborators = {
        ...activity,
        Users: users.map((user) => ({
            User: {
                id_e: user,
            },
        })),
    } as unknown as TSectionActivity;

    const [activityState, setActivityState] = useState<
        TSectionActivity | undefined
    >();

    const { state } = useLocation();

    const { mutate: updateSubItemMutation } = useMutation({
        mutationFn: () =>
            activities.updateSubItem({
                title,
                users,
                subtaskId: subItem.id_e,
                finished: Boolean(subItem.finished_at),
            }),
        onSuccess: async () => {
            queryClient.fetchQuery(["readActivities", activity.id_e]);
            setEditSubItem(false);
        },
    });

    return (
        <>
            {activityState && (
                <AddCollaboratorsModal
                    activity={activityState}
                    project={state?.project}
                    onSuccess={(data) => {
                        setUsers(data.users);
                        setActivityState(undefined);
                    }}
                    setActivity={setActivityState}
                />
            )}
            <s.Container
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        updateSubItemMutation();
                    }
                }}
            >
                <s.Content>
                    <Input
                        mask=""
                        placeholder="Edite o título"
                        value={title}
                        ref={(input) => input?.focus()}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    <s.UserAddButton
                        onClick={() =>
                            setActivityState(activityToAddCollaborators)
                        }
                    >
                        <Icons.UserAdd color={theme.gray800} />
                    </s.UserAddButton>
                    {users.length > 0 && (
                        <s.UsersLength>+{users.length}</s.UsersLength>
                    )}
                </s.Content>
                <s.Buttons>
                    <SecondaryButton onClick={() => setEditSubItem(false)}>
                        CANCELAR
                    </SecondaryButton>
                    <PrimaryButton onClick={updateSubItemMutation}>
                        SALVAR
                    </PrimaryButton>
                </s.Buttons>
            </s.Container>
        </>
    );
};
